module.exports = __webpack_public_path__ + "img/motor_no45.0b491ba5.jpg";